export enum StringId {
  LOCALE_NAME = 'localeName',
  LOCALE_SYMBOL = 'localeSymbol',
  CADET = 'cadet',
  EXAMPLE_TEMPLATE = 'exampleTemplate',

  // Top-level menu titles
  FILE_MENU = 'fileMenu',
  EDIT_MENU = 'editMenu',
  VIEW_MENU = 'viewMenu',
  WINDOW_MENU = 'windowMenu',
  HELP_MENU = 'helpMenu',

  SHIFT_KEY = 'Shift',
  CTRL_KEY = 'Control',
  ALT_KEY = 'Alt',
  OPTION_KEY = 'Option',
  META_KEY = 'Meta',

  UNDO_COMMAND = 'undoCommand',
  UNDO_DESCRIPTION = 'undoDescription',
  UNDO_DISABLED = 'undoDisabled',
  REDO_COMMAND = 'redoCommand',
  REDO_DESCRIPTION = 'redoDescription',
  REDO_DISABLED = 'redoDisabled',

  CANCEL_COMMAND = 'cancelCommand',
  CANCEL_DRAG_COMMAND = 'cancelDragCommand',

  ZOOM_TO_FIT_COMMAND = 'zoomToFitCommand',
  ZOOM_TO_100_PERCENT_COMMAND = 'zoomTo100PercentCommand',
  ZOOM_TO_200_PERCENT_COMMAND = 'zoomTo200PercentCommand',

  CENTER_ON_POINT_COMMAND = 'centerOnPointCommand',
  FOCUS_SELECTION_COMMAND = 'focusSelectionCommand',

  NEXT_LOCALE_COMMAND = 'nextLocaleCommand',
  PREV_LOCALE_COMMAND = 'prevLocaleCommand',

  TOGGLE_COLOR_MODE_COMMAND = 'toggleColorModeCommand',

  COLOR_MODE_LIGHT = 'colorModeLight',
  COLOR_MODE_DARK = 'colorModeDark',
  COLOR_MODE_SYSTEM = 'colorModeSystem',

  CREATE_TOOL_NAME = 'createToolName',
  CREATE_TOOL_SHORT_NAME = 'createToolShortName',
  CREATE_TOOL_DESCRIPTION = 'createToolDescription',

  SELECT_TOOL_NAME = 'selectToolName',
  SELECT_TOOL_SHORT_NAME = 'selectToolShortName',
  SELECT_TOOL_DESCRIPTION = 'selectToolDescription',

  ARRANGE_TOOL_NAME = 'arrangeToolName',
  ARRANGE_TOOL_SHORT_NAME = 'arrangeToolShortName',
  ARRANGE_TOOL_DESCRIPTION = 'arrangeToolDescription',

  PAN_TOOL_NAME = 'panToolName',
  PAN_TOOL_SHORT_NAME = 'panToolShortName',
  PAN_TOOL_DESCRIPTION = 'panToolDescription',

  CREATE_UNIT_COMMAND = 'createUnitCommand',
  DELETE_SELECTION_COMMAND = 'deleteSelectionCommand',
  GROUP_SELECTION_COMMAND = 'groupSelectionCommand',
  REVERSE_EDGES_COMMAND = 'reverseEdgesCommand',

  SELECT_ALL_COMMAND = 'selectAllCommand',
  DESELECT_ALL_COMMAND = 'deselectAllCommand',
  DESELECT_EDGES_COMMAND = 'deselectEdgesCommand',
  REVEAL_SELECTION_COMMAND = 'revealSelectionCommand',

  SELECT_SUCCESSORS_COMMAND = 'selectSuccessorsCommand',
  SELECT_ALL_SUCCESSORS_COMMAND = 'selectAllSuccessorsCommand',
  SELECT_PREDECESSORS_COMMAND = 'selectPredecessorsCommand',
  SELECT_ALL_PREDECESSORS_COMMAND = 'selectAllPredecessorsCommand',
  SELECT_NEIGHBORS_COMMAND = 'selectNeighborsCommand',
  SELECT_ALL_NEIGHBORS_COMMAND = 'selectAllNeighborsCommand',

  COLLAPSE_GROUPS_COMMAND = 'collapseGroupsCommand',
  DEEP_COLLAPSE_GROUPS_COMMAND = 'deepCollapseGroupsCommand',
  EXPAND_GROUPS_COMMAND = 'expandGroupsCommand',
  DEEP_EXPAND_GROUPS_COMMAND = 'deepExpandGroupsCommand',

  SHOW_EDITOR_COMMAND = 'showEditorCommand',
  CANCEL_EDITOR_COMMAND = 'cancelEditorCommand',

  ERROR_GENERIC = 'errorGeneric',
  ERROR_CANNOT_MOVE_GROUP_INTO_ITSELF = 'errorCannotMoveGroupIntoItself',
  ERROR_TOO_MANY_NODES = 'errorTooManyNodes',

  RELOAD_WINDOW_COMMAND = 'reloadWindowCommand',

  LAYOUT_LEFT_TO_RIGHT = 'layoutLeftToRight',
  LAYOUT_RIGHT_TO_LEFT = 'layoutRightToLeft',
  LAYOUT_TOP_TO_BOTTOM = 'layoutTopToBottom',
  LAYOUT_BOTTOM_TO_TOP = 'layoutBottomToTop',
  LAYOUT_UNCONSTRAINED = 'layoutUnconstrained',

  TOGGLE_BUNDLED_ROUTING = 'toggleBundledRouting',
  TOGGLE_ALIGN_ROOTS = 'toggleAlignRoots',
  TOGGLE_ALIGN_LEAVES = 'toggleAlignLeaves',

  SCREENCAST_MODE = 'screencastMode',

  LEFT_BAR = 'leftBar',
  SHOW = 'show',
  HIDE = 'hide',

  SET_SELECTED_UNITS_CLASS_COMMAND = 'setSelectedUnitsClassCommand',
  SET_LOCALE_COMMAND = 'setLocaleCommand',

  // Only user-facing colors have translations in `strings.json`.
  FOREGROUND = 'foreground',
  RED = 'red',
  ORANGE = 'orange',
  YELLOW = 'yellow',
  GREEN = 'green',
  MINT = 'mint',
  TEAL = 'teal',
  CYAN = 'cyan',
  BLUE = 'blue',
  INDIGO = 'indigo',
  PURPLE = 'purple',
  PINK = 'pink',
  BROWN = 'brown',
  GRAY = 'gray',
  BLACK = 'black',
  WHITE = 'white'
}
